module.exports = __webpack_public_path__ + "img/icon_shangshen_green.19225bac.svg";